import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import { msalConfig } from "./msalConfig";
import Layout from "./components/Layout";
import Home from "./components/Home";
import Services from "./components/Services";
import Careers from "./components/Careers";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Login from "./components/Login";
import NotFound from "./components/NotFound";
import reportWebVitals from "./reportWebVitals";

import "./styles/theme.css";

const msalInstance = new PublicClientApplication(msalConfig);

// Route paths are kept identical to v1 so existing links and bookmarks
// continue to resolve.
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="Services/Services" element={<Services />} />
      <Route path="JobAvailability/JobAvailability" element={<Careers />} />
      <Route
        path="TermsAndConditions/TermsAndConditions"
        element={<TermsAndConditions />}
      />
      <Route path="PrivacyPolicy/PrivacyPolicy" element={<PrivacyPolicy />} />
      <Route path="login" element={<Login />} />
      <Route path="support" element={<Login />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  ),
  // Opt in to the v7 behaviours now so the console stays clean and the
  // upgrade is a version bump rather than a migration.
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);

// MsalProvider initializes the instance itself; rendering is not gated on it
// so a tenant outage can never blank the marketing site.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();
